import { render } from "./RankingsPanel.vue?vue&type=template&id=bb3289a6&scoped=true"
import script from "./RankingsPanel.vue?vue&type=script&lang=js"
export * from "./RankingsPanel.vue?vue&type=script&lang=js"

import "./RankingsPanel.vue?vue&type=style&index=0&id=bb3289a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3289a6"]])

export default __exports__